"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDtoToJSON = exports.UserDtoFromJSONTyped = exports.UserDtoFromJSON = exports.instanceOfUserDto = exports.UserDtoRoleEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.UserDtoRoleEnum = {
    Physician: 'physician',
    Patient: 'patient',
    LabDirector: 'lab_director',
    Staff: 'staff',
    Null: 'null'
};
/**
 * Check if a given object implements the UserDto interface.
 */
function instanceOfUserDto(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    return isInstance;
}
exports.instanceOfUserDto = instanceOfUserDto;
function UserDtoFromJSON(json) {
    return UserDtoFromJSONTyped(json, false);
}
exports.UserDtoFromJSON = UserDtoFromJSON;
function UserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phone': !(0, runtime_1.exists)(json, 'phone') ? undefined : json['phone'],
        'fax': !(0, runtime_1.exists)(json, 'fax') ? undefined : json['fax'],
        'contactEmail': !(0, runtime_1.exists)(json, 'contactEmail') ? undefined : json['contactEmail'],
        'address1': !(0, runtime_1.exists)(json, 'address1') ? undefined : json['address1'],
        'address2': !(0, runtime_1.exists)(json, 'address2') ? undefined : json['address2'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
        'state': !(0, runtime_1.exists)(json, 'state') ? undefined : json['state'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'zipcode': !(0, runtime_1.exists)(json, 'zipcode') ? undefined : json['zipcode'],
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : json['role'],
        'persona': !(0, runtime_1.exists)(json, 'persona') ? undefined : json['persona'],
        'npi': !(0, runtime_1.exists)(json, 'npi') ? undefined : json['npi'],
    };
}
exports.UserDtoFromJSONTyped = UserDtoFromJSONTyped;
function UserDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
        'fax': value.fax,
        'contactEmail': value.contactEmail,
        'address1': value.address1,
        'address2': value.address2,
        'country': value.country,
        'state': value.state,
        'city': value.city,
        'zipcode': value.zipcode,
        'role': value.role,
        'persona': value.persona,
        'npi': value.npi,
    };
}
exports.UserDtoToJSON = UserDtoToJSON;
